/* @flow */
// typecheck: ignore file
import React from 'react';
import BoxBody from 'components/BoxBody.jsx';
import Dialog from 'components/Dialog.jsx';
import Link from 'components/Link.jsx';
import Input from 'components/Input.jsx';
import MediaObject from 'components/MediaObject.jsx';
import ProfilePicture from 'user/components/ProfilePicture.jsx';
import Text from 'components/Text.jsx';

import './styles/AddParentChildModal.scss';

type Props = {
  title: string,
  relation: 'parent' | 'child',
  onRequestHide: () => void,
};

type State = {
  query: string,
}

class AddParentChildModal extends React.Component {
  props: Props;
  state: State;

  state = {
    query: '',
  }

  addNewParentOrChild = () => {
    // TODO add the person
    this.props.onRequestHide();
  }

  addExistingParentOrChild = () => {
    // TODO
    this.props.onRequestHide();
  }

  performSearch = (event: SyntheticEvent) => {
    this.setState({
      // $FlowFixMe
      query: event.target.value,
    });
  }

  renderEmptyQuery() {
    const text = this.props.relation === 'parent' ?
      'Search for your parent by first or last name' :
      'Search for your child by first or last name';

    return (
      <Text
        className="AddParentChildModal-empty-query"
        element="div"
        color="koala"
        size="large">
        {text}
      </Text>
    );
  }

  renderResultList() {
    // TODO: foreach render this with real results
    return (
      <Link
        className="AddParentChildModal-result-item"
        block
        onClick={this.addExistingParentOrChild}>
        <MediaObject
          className="AddParentChildModal-result-item-inner"
          gutter="small">
          <div>
            <ProfilePicture
              size="medium"
              user={{ initials: 'AZ' }}
            />
          </div>
          <Text element="div">
            Abba Zabba
          </Text>
        </MediaObject>
      </Link>
    );
  }

  renderAddPerson() {
    const isParent = this.props.relation === 'parent';
    const buttonText = isParent ? 'Add parent' : 'Add child';
    const h1Text = isParent ? 'Don’t see your parent?' : 'Don’t see your child?';
    const h2Text = isParent ?
      'Your parent must be first added to a class so that you can connect them' :
      'Your child must be first added to a class so that you can connect them';

    return (
      <BoxBody>
        <Text
          size="large"
          element="p">
          {h1Text}
        </Text>
        <Text
          color="thunder"
          element="p">
          {h2Text}
        </Text>
        <Link
          block
          weight="semibold"
          onClick={this.addNewParentOrChild}>
          {buttonText}
        </Link>
      </BoxBody>
    );
  }

  render() {
    const placeholderText = this.props.relation === 'parent' ? 'Search for a parent' : 'Search for a child';

    return (
      <Dialog
        eventScreenName={this.props.relation === 'parent' ? 'AddParentModal' : 'AddChildModal'}
        className="AddParentChildModal"
        size="small"
        onRequestHide={this.props.onRequestHide}
        title={this.props.title}>
        <BoxBody full>
          <div className="AddParentChildModal-input">
            <Input
              autofocus
              glyph="search"
              placeholder={placeholderText}
              onChange={this.performSearch}
            />
          </div>
        </BoxBody>
        <div className="AddParentChildModal-content">
          {!this.state.query && this.renderEmptyQuery()}
          {this.state.query && this.renderResultList()}
          {this.state.query && this.renderAddPerson()}
        </div>
      </Dialog>
    );
  }
}

export default AddParentChildModal;



// WEBPACK FOOTER //
// ./src/settings/components/AddParentChildModal.jsx